/**
 * 検索結果
 */
export class KYMW1102SearchResultModel {
  public selectValue: boolean = <boolean>false;
  public PCode: string = <string>'';
  public ClassDivNum: string = <string>'';
  public ClassCode: string = <string>'';
  public MiddleClassCode: string = <string>'';
  public SmallClassCode: string = <string>'';
  public GuideGoodsName: string = <string>'';
  public GuideStandardName: string = <string>'';
  public ConsumeTerm: string = <string>'';
  public ConsymeByDate: string = <string>'';
  public SetDiv: string = <string>'';
  public LongKeepDiv: string = <string>'';
  public AssortTempDiv: string = <string>'';
  public ItemCode: string = <string>'';
  public JanCode: string = <string>'';
  public BrandType: string = <string>'';
  public OrderClientCode: string = <string>'';
  public MakerName: string = <string>'';
  public EbaseSpecCode: string = <string>'';
  public PeaceSizeLength: string = <string>'';
  public PeaceSizeWidth: string = <string>'';
  public PeaceSizeHeight: string = <string>'';
  public CaseSizeLength: string = <string>'';
  public CaseSizeWidth: string = <string>'';
  public CaseSizeHeight: string = <string>'';
  public RegistCatalogRound: string = <string>'';
  public ClassNameKanji: string = <string>'';
  public MiddleClassNameKanji: string = <string>'';
  public SmallClassNameKanji: string = <string>'';
  public SupplyPriceStandard: string = <string>'';
  public SupplyPriceSpecial1: string = <string>'';
  public SupplyPriceSpecial2: string = <string>'';
  public SupplyTaxWithoutStd: string = <string>'';
  public SupplyTaxWithoutSpc1: string = <string>'';
  public SupplyTaxWithoutSpc2: string = <string>'';
  public CostPriceStandard: string = <string>'';
  public CostPriceSpecial1: string = <string>'';
  public CostPriceSpecial2: string = <string>'';
  public BrandTypeName: string = <string>'';
  public AssortTempDivName: string = <string>'';
  public SetDivName: string = <string>'';
  public LongkeepDivName: string = <string>'';
  public OrderClientName: string = <string>'';
  // 消費税区分
  public ConsumeTaxDiv: string = <string>'';
  // 消費税率
  public ConsumeTaxRate: string = <string>'';

  public proMonth: string = <string>'';
  public proKai: string = <string>'';
  public supplyPrice: string = <string>'';
  public supplyPlan: string = <string>'';
  public pointPlan: string = <string>'';

  public outputYear: string = <string>'';
  public outputMonth: string = <string>'';
  public outputKai: string = <string>'';
  public outputChargePerson: string = <string>'';

  public PCodes: Array<any> = new Array<any>();
  public ClassDivNums: Array<any> = new Array<any>();
  public ClassCodes: Array<any> = new Array<any>();
  public MiddleClassCodes: Array<any> = new Array<any>();
  public SmallClassCodes: Array<any> = new Array<any>();
  public GuideGoodsNames: Array<any> = new Array<any>();
  public GuideStandardNames: Array<any> = new Array<any>();
  public ConsumeTerms: Array<any> = new Array<any>();
  public ConsymeByDates: Array<any> = new Array<any>();
  public SetDivs: Array<any> = new Array<any>();
  public LongKeepDivs: Array<any> = new Array<any>();
  public AssortTempDivs: Array<any> = new Array<any>();
  public ItemCodes: Array<any> = new Array<any>();
  public JanCodes: Array<any> = new Array<any>();
  public BrandTypes: Array<any> = new Array<any>();
  public OrderClientCodes: Array<any> = new Array<any>();
  public MakerNames: Array<any> = new Array<any>();
  public EbaseSpecCodes: Array<any> = new Array<any>();
  public PeaceSizeLengths: Array<any> = new Array<any>();
  public PeaceSizeWidths: Array<any> = new Array<any>();
  public PeaceSizeHeights: Array<any> = new Array<any>();
  public CaseSizeLengths: Array<any> = new Array<any>();
  public CaseSizeWidths: Array<any> = new Array<any>();
  public CaseSizeHeights: Array<any> = new Array<any>();
  public RegistCatalogRounds: Array<any> = new Array<any>();
  public ClassNameKanjis: Array<any> = new Array<any>();
  public MiddleClassNameKanjis: Array<any> = new Array<any>();
  public SmallClassNameKanjis: Array<any> = new Array<any>();
  public SupplyPriceStandards: Array<any> = new Array<any>();
  public SupplyPriceSpecial1s: Array<any> = new Array<any>();
  public SupplyPriceSpecial2s: Array<any> = new Array<any>();
  public SupplyTaxWithoutStds: Array<any> = new Array<any>();
  public SupplyTaxWithoutSpc1s: Array<any> = new Array<any>();
  public SupplyTaxWithoutSpc2s: Array<any> = new Array<any>();
  public CostPriceStandards: Array<any> = new Array<any>();
  public CostPriceSpecial1s: Array<any> = new Array<any>();
  public CostPriceSpecial2s: Array<any> = new Array<any>();
  public BrandTypeNames: Array<any> = new Array<any>();
  public AssortTempDivNames: Array<any> = new Array<any>();
  public SetDivNames: Array<any> = new Array<any>();
  public LongkeepDivNames: Array<any> = new Array<any>();
  public OrderClientNames: Array<any> = new Array<any>();
  public proMonths: Array<any> = new Array<any>();
  public proKais: Array<any> = new Array<any>();
  public pointPlans: Array<any> = new Array<any>();
  public supplyPlans: Array<any> = new Array<any>();
  // 消費税区分
  public ConsumeTaxDivs: Array<any> = new Array<any>();
  // 消費税率
  public ConsumeTaxRates: Array<any> = new Array<any>();
}
